import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerProps,
  HStack,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import { LocationIcon, MailIcon, } from '../../constants/svgs';
import { headerLinks, headerLinksEn } from '../../constants/links';

import LanguageSwitcher from '../languageSwitcher/languageSwitcher';
import React from 'react';
import SocialIcons from '../socials/social-icons';
import useLanguage from '../../hooks/useLanguage';

export const MobileDrawer = (props: Omit<DrawerProps, 'children'>) => {
  const isEnglish = useLanguage();

  const headerlinks = isEnglish ? headerLinksEn : headerLinks;
  return (
    <Drawer placement="top" {...props}>
      <DrawerContent className="header_modal">
        <DrawerBody py="24px">
          <VStack spacing="6" alignItems="center" gap="20px">
            <LanguageSwitcher />
            <Accordion allowToggle>
              <AccordionItem border="none">

                <AccordionButton justifyContent="center" bg="transparent !important" fontSize="16px" fontWeight="600" p="0px">
                  {isEnglish ? "About the Project" : "O пројекту"}
                  <AccordionIcon />
                </AccordionButton>

                <AccordionPanel paddingBottom="0px">
                  <VStack>
                    <Link
                      fontSize="16px"
                      fontWeight="600"
                      href={isEnglish ? "/en/about" : "/o-nama"}
                      _hover={{
                        color: 'rawSienna.500',
                        textDecor: 'none',
                      }}>{isEnglish ? "About us" : "O нама"}</Link>
                    <Link

                      fontSize="16px"
                      fontWeight="600"
                      href={isEnglish ? "/en/lighthouse-generations" : "/generacije-svetionika"}
                      _hover={{
                        color: 'rawSienna.500',
                        textDecor: 'none',
                      }}
                    >{isEnglish ? "Lighthouse Generations" : "Генерације светионика"}</Link>
                  </VStack>

                </AccordionPanel>
              </AccordionItem>
            </Accordion>
            {headerlinks.map((item: { text: string; href: string }) => (
              <Link
                key={item.text}
                fontSize="16px"
                fontWeight="600"
                href={item.href}
                _hover={{
                  color: 'rawSienna.500',
                  textDecor: 'none',
                }}
              >
                {item.text}
              </Link>
            ))}
            <Link href={isEnglish ? "/en/contact" : "/kontakt"}>
              <Button variant="solid" w="100%" fontSize="16px">
                {isEnglish ? "Apply for the 8th editions" : "Пријави се на осму генерацију"}

              </Button>
            </Link>
            <VStack w="100%" borderTop="1px solid #EEEDF1" gap="24px" pt="20px">

              <HStack alignItems="center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: MailIcon('#BC2A2A', '16px', '16px'),
                  }}
                />

                <Link
                  className="grid-numbers"
                  href="mailto:info@svetionikznanja.rs"
                  mt="0px !important"
                  fontSize="14px"
                  fontWeight="500"
                >
                  info@svetionikznanja.rs
                </Link>
              </HStack>
              <HStack alignItems="center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: LocationIcon('#BC2A2A', '16px', '16px'),
                  }}
                />

                <Text
                  className="grid-numbers"
                  mt="0px !important"
                  fontSize="14px"
                  fontWeight="500"
                  color="gunPowder.900"
                >
                  {isEnglish ? "Brsjačka 28, 11000 Belgrade" : "Брсјачка 28, 11000 Београд"}
                </Text>
              </HStack>
            </VStack>
            <VStack w="100%">
              <SocialIcons
                paddingTop='12px'
                bgColor="rawSienna.500"
                iconColor="white"
                hoverColor="rawSienna.400"
                size="16px"
                bgSize="40px"
              />
            </VStack>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer >
  )
};
